import styled from 'styled-components'
import { clickDown } from '../../animations/Transitions'
import { cyberColors } from '../../lib/colors'

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: solid 1px #35353f;
  padding-bottom: 15px;
`

export const Title = styled.div`
  font-size: 28px;
  text-transform: uppercase;
  color: ${cyberColors.whiteText};
`

export const Close = styled.div`
  cursor: pointer;
  .btn {
    width: 100%;
    cursor: pointer;
    transform: scale(1) rotate(0);
    transition: all 0.167s;
    transition-timing-function: cubic-bezier(0.39, 0.575, 0.565, 1);
    :active {
      ${clickDown}
    }
    :hover {
      transform: scale(0.6);
      transition: all 0.167s;
      transition-timing-function: cubic-bezier(0.39, 0.575, 0.565, 1);
    }
  }
`
